import { useToggle } from "@dewo/app/util/hooks";
import { Button, ButtonProps } from "antd";
import React, { FC, useCallback } from "react";
import { LoginModal } from "../LoginModal";

interface Props extends ButtonProps {
  redirect?: string;
  onAuthedWithWallet?(): any;
}

export const LoginButton: FC<Props> = ({
  onAuthedWithWallet,
  onClick,
  redirect,
  ...props
}) => {
  const modalVisible = useToggle();
  const handleClick = useCallback(
    (e) => {
      onClick?.(e);
      modalVisible.toggleOn();
    },
    [onClick, modalVisible]
  );
  const handleAuthedWithWallet = useCallback(() => {
    onAuthedWithWallet?.();
    modalVisible.toggleOff();
  }, [onAuthedWithWallet, modalVisible]);
  return (
    <>
      <Button {...props} onClick={handleClick} />
      <LoginModal
        redirect={redirect}
        visible={modalVisible.isOn}
        onClose={modalVisible.toggleOff}
        onAuthedWithWallet={handleAuthedWithWallet}
      />
    </>
  );
};
